// import WorkingHour from './WorkingHour';

export default {
  priority: 96,
  name: app.translate('routes.home.attendance.working-hours.Working Hours'),
  path: 'working-hours',
  permissions: ['TimeAttendanceMenu/WorkingHourMenu'],
  // component: WorkingHour,
  component: load(() => import(/* webpackChunkName: "WorkingHour" */ './WorkingHour')),
  icon: 'clock',
  drawer: true,
};


